import script from "./BlockOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockOverlay.vue?vue&type=script&setup=true&lang=js"

import "./BlockOverlay.vue?vue&type=style&index=0&id=1a0a0bc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0a0bc6"]])

export default __exports__